/* ============================================================
   VIVĀRA — FILM (click-to-play YouTube embed)
   ------------------------------------------------------------
   Why this exists rather than a plain <iframe>:

   · A self-hosted MP4 is used when one is supplied (`data-film-mp4`), and
     plays inline everywhere — including straight off disk. Give the section
     a video file and YouTube stops being involved at all.
   · Otherwise: YouTube refuses to play an embed that arrives without a valid
     origin. Opening the build straight off disk (file://) sends
     "Origin: null", and the player answers with "Video unavailable —
     error 153". Nothing about the video or the markup is wrong; the
     protocol is. So on file:// we open the video on youtube.com
     instead of embedding it, and everywhere else we embed normally.
   · Nothing from YouTube is requested until the visitor presses play,
     so the page loads no third-party script and sets no cookie unless
     they ask for the film. That keeps this section out of consent-
     banner territory and off the critical path.

   SHOPIFY MIGRATION → assets/film.js, loaded by sections/video.liquid.
   The video id lives on the button (data-film), so it becomes a
   section setting with no code change.
   ============================================================ */
(function () {
  "use strict";

  var EMBED = "https://www.youtube.com/embed/";
  var WATCH = "https://www.youtube.com/watch?v=";

  /* A local file has no origin YouTube will accept. */
  function canEmbed() {
    return window.location.protocol === "http:" || window.location.protocol === "https:";
  }

  function play(button) {
    var mp4 = button.getAttribute("data-film-mp4");
    var id = button.getAttribute("data-film");

    /* A self-hosted file is always preferred: it plays inline everywhere,
       including from a local file, and needs nothing from YouTube. */
    if (mp4) {
      var v = document.createElement("video");
      v.src = mp4;
      v.controls = true;
      v.autoplay = true;
      v.playsInline = true;
      v.setAttribute("playsinline", "");
      v.preload = "auto";
      var poster = button.querySelector("[data-film-fallback]");
      if (poster && poster.getAttribute("src")) v.poster = poster.getAttribute("src");
      button.parentNode.replaceChild(v, button);
      v.play().catch(function () { /* the controls are there if autoplay is blocked */ });
      return;
    }

    if (!id) return;

    if (!canEmbed()) {
      window.open(WATCH + id, "_blank", "noopener");
      return;
    }

    var frame = document.createElement("iframe");
    frame.src = EMBED + id + "?autoplay=1&rel=0&playsinline=1";
    frame.title = button.getAttribute("aria-label") || "Video";
    frame.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    frame.referrerPolicy = "strict-origin-when-cross-origin";
    frame.allowFullscreen = true;
    frame.setAttribute("frameborder", "0");

    var host = button.parentNode;
    host.replaceChild(frame, button);
    frame.focus();
  }

  function init() {
    document.querySelectorAll("[data-film]").forEach(function (button) {
      /* If the poster 404s, fall back to the smaller still YouTube always has. */
      var poster = button.querySelector("[data-film-fallback]");
      if (poster) {
        var tried = false;
        poster.addEventListener("error", function () {
          if (!tried) {
            tried = true;
            poster.src = poster.getAttribute("data-film-fallback");
            return;
          }
          /* Neither still is reachable — drop the image rather than leave a
             broken-image glyph over the frame. The play mark still reads. */
          poster.style.display = "none";
        });
      }

      /* Off a served origin, with no self-hosted file, the button leaves for
         YouTube — say so rather than appearing to fail. */
      if (!canEmbed() && !button.getAttribute("data-film-mp4")) {
        var label = button.querySelector(".film-play-label");
        if (label) label.textContent = "Watch the film on YouTube";
      }

      button.addEventListener("click", function () { play(button); });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
